import { Grid, Skeleton, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import NumberFormat from 'react-number-format';
import { SourceUse } from '../../shared/models';

interface SourcesUsesProps {
	isLoading: boolean;
	sources: SourceUse[] | null | undefined;
	uses: SourceUse[] | null | undefined;
}

export const SourcesUses: React.FC<SourcesUsesProps> = ({ isLoading, sources, uses }) => {
	if (isLoading) {
		return (
			<Grid container>
				<Grid item md={6} sm={12}>
					<Skeleton height={80} />
					<Skeleton height={80} />
				</Grid>
				<Grid item md={6} sm={12}>
					<Skeleton height={80} />
					<Skeleton height={80} />
				</Grid>
			</Grid>
		);
	}

	return (
		<Grid container>
			<Grid item md={6} sm={12} paddingLeft={5} paddingRight={5}>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>Source</TableCell>
								<TableCell>Amount</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{sources?.map(source => (
								<TableRow key={source.sourceName}>
									<TableCell>{source.sourceName}</TableCell>
									<TableCell>
										<NumberFormat
											value={source.amount}
											displayType="text"
											thousandSeparator={true}
											prefix="$"
										/>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</Grid>
			<Grid item md={6} sm={12}>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>Use</TableCell>
								<TableCell>Amount</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{uses?.map(use => (
								<TableRow key={use.sourceName}>
									<TableCell>{use.sourceName}</TableCell>
									<TableCell>
										<NumberFormat
											value={use.amount}
											displayType="text"
											thousandSeparator={true}
											prefix="$"
										/>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</Grid>
		</Grid>
	);
};
